import React, { Component, Fragment } from 'react';
import { inject, observer } from 'mobx-react';
import Map from '../../../../../common/components/Map';

import './NoticeMap.css';
import { renderToString } from 'react-dom/server';
import { MarkerBellIcon } from '../../../../../common/icons';

@inject('translationsStore')
@observer
export default class NoticeMap extends Component {
  constructor(props) {
    super(props);

    this.MapRef = React.createRef();
  }

  markersMapper = car => {
    const {
      position: { lat, lng }
    } = this.props;

    let marker = {
      ...car,
      icon: (function() {
        return renderToString(<MarkerBellIcon />);
      })(),
      lng,
      lat
    };
    return marker;
  };

  render() {
    const { translationsStore } = this.props;
    const {
      data,
      position,
      position: { available }
    } = this.props;

    return (
      <Fragment>
        {available ? (
          <Map
            ref={this.MapRef}
            formatDistanceToNow
            onTap={() => false}
            noticeMarkers={[data]}
            className="DetailMap"
            markerId="plate"
            style={{
              height: '100%',
              right: '0',
              width: '100%'
            }}
            markersFilter={() => !!position}
            markersMapper={this.markersMapper}
          />
        ) : (
          <div className="PositionNotAvailable">
            <div>{translationsStore.translate('notices.modalCarousel.positionNotAvailable')}</div>
          </div>
        )}
      </Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/App/NoticesLoader/NoticeDetail/NoticeMap/NoticeMap.js